import { gsap } from "gsap";
import { SplashView } from "../SplashController";
import { Helper } from "../../../../dev/utils/Helper";
import { Translator } from "../../../../dev/setting/Translator";
import { GameAssets } from "../../../config/texture/GameAssets";
import { BitmapCountUp } from "../../../component/BitmapCountUp";
import { FontWeight } from "@nolimitcity/slot-launcher/bin/loader/font/FontStatics";
import { TranslationTexts } from "../../../config/translate/TranslationTexts";
import { GameData, InitData } from '../../../server/data/BaseModel';
import { SpinePlayer } from '../../../../dev/displayobject/SpinePlayer';
import { ArrayHelper } from '../../../../dev/utils/ArrayHelper';
import { SoundConfig } from '../../../config/sound/SoundConfig';
import { SoundManager } from '../../../config/sound/SoundManager';
import { BitmapTextStyleOptions, TextStyleOptions } from "../../../../dev/setting/text/IText";

export class SplashViewFreeSpins extends PIXI.Container implements SplashView {

    private _txt: PIXI.Text;
    private _txtFS: PIXI.Text;
    private _txtWon: PIXI.Text;

    private poster: SpinePlayer;
    private counter: BitmapCountUp;

    private spineAnimation: string;

    private readonly _style: BitmapTextStyleOptions = {
        fontName: GameAssets.BITMAP_FONT_FS_NUMBERS,
        fontSize: 62,
        tint: 0xffffff,
        letterSpacing: 0
    };

    private readonly minorTxtstyle: TextStyleOptions = {
        fontWeight: FontWeight.BOLD,
        
        fontFamily: "Helvetica",
        align: "center",
        fill: "#ffff00",
        
        fontSize: 22,
        wordWrap: true,
        wordWrapWidth: 500,

        dropShadow: true,
        dropShadowAngle: 8,
        dropShadowBlur: 4,
        dropShadowDistance: 4,
    };

    private readonly styleTotal: TextStyleOptions = {
        fontFamily: "Helvetica",
        fontSize: 58,
        fontWeight: FontWeight.EXTRA_BOLD,
        fill: [
            "#fffb00",
            "#c93",
        ],
        stroke: "#600",
        strokeThickness: 4
    };


    private _timeLine: gsap.core.Timeline;
    private introSound: string;

    private DEFAULT_TXT_STYLE: TextStyleOptions;

    constructor(textStyle: TextStyleOptions) {
        super();
        this.DEFAULT_TXT_STYLE = textStyle;
        this.init();
    }

    private init(): void {
        this._txt = new PIXI.Text(Translator.translate(TranslationTexts.CONGRATULATIONS));
        this._txt.style = this.styleTotal;
        this.addChild(this._txt);
        this._txt.position = new PIXI.Point(0, -220);
        this._txt.anchor.set(0.5, 0.5);

        Helper.ResizeText(this._txt,600)

        this._txtWon = new PIXI.Text(Translator.translate(TranslationTexts.YOU_WON));
        this._txtWon.style = this.DEFAULT_TXT_STYLE;
        this._txtWon.style.fontSize = 52;
        this.addChild(this._txtWon);
        this._txtWon.position = new PIXI.Point(0, -120);
        this._txtWon.anchor.set(0.5, 0.5);

        Helper.ResizeText(this._txtWon,600)

        this.counter = this.addChild(new BitmapCountUp(this._style));
        this.counter.alpha = 1;
        this.counter.anchor = new PIXI.Point(0.5, 0.5);
        this.counter.position.set(0, -40)
        this.addChild(this.counter);

        this._txtFS = new PIXI.Text(Translator.translate(TranslationTexts.FREESPINS));
        this.DEFAULT_TXT_STYLE.fontSize = 40;
        this._txtFS.style = this.DEFAULT_TXT_STYLE;
        this.addChild(this._txtFS);
        this._txtFS.position = new PIXI.Point(0, 140);
        this._txtFS.anchor.set(0.5, 0.5);

        Helper.ResizeText(this._txtFS,600)

        this.poster = this.addChild(new SpinePlayer("FS_Intro", true));

        this.counter.showValue(4, false);

        this.visible = false;
    }

    public play(): gsap.core.Timeline {
        this._timeLine = Helper.setTimeline(this._timeLine, new gsap.core.Timeline({ onStart: () => { this.visible = true } }));
        this._timeLine.fromTo(this, { alpha: 0 }, { duration: 0.5, alpha: 1 }, 0);

        this._timeLine.add(this.poster.play({ animation: this.spineAnimation }), 0)
        SoundManager.playSoundEffect(this.introSound);
        SoundManager.emptyLoop();

        this._timeLine.fromTo([
            this.counter, this._txt, this._txtFS, this._txtWon]
            , { alpha: 0 }, { alpha: 1, duration: 0.35 });
        this._timeLine.add(() => { SoundManager.playSoundEffect(SoundConfig.SPLASH_INTRO_CONGRATS) })

        return this._timeLine;
    }

    setData(data: GameData & InitData): void {
        const bonusLvl = ArrayHelper.countWithCondition(data.Reel.reelsWithScatters, (v) => v);
        this._txtFS.text = Translator.translate(txtToGet(bonusLvl));
        this.spineAnimation = spineAnimation(bonusLvl);

        this.introSound = introSoundVal(bonusLvl);

        this.counter.showValue(data.raw.freespinsLeft - Helper.fetchOrApply(data.fsInfo.addedNumberOfFreespinsThisSpin, 0), false);

        function txtToGet(val: number): string {
            switch (val) {
                case 3:
                    return TranslationTexts.FREESPINS;
                case 4:
                    return TranslationTexts.FREESPINS_SUPER;
                default:
                    return TranslationTexts.FREESPINS_UBER;
            }
        }

        function introSoundVal(val: number): string {
            return SoundConfig.SPLASH_INTRO[val - 3];
        }

        function spineAnimation(val: number): string {
            switch (val) {
                case 3:
                    return "FS_Intro_Rush";
                case 4:
                    return "FS_Intro_Jam";
                default:
                    return "FS_Intro_Mayhem";
            }
        }
    }

    public stop(): gsap.core.Timeline {
        this._timeLine = Helper.setTimeline(this._timeLine, new gsap.core.Timeline({ onComplete: () => { this.visible = false } }));
        this._timeLine.to(this, { duration: 0.35, alpha: 0 });
        return this._timeLine;
    }

    public onResize(): void {
        if (this._timeLine) this._timeLine.progress(1);
    }
}
